module.exports = __webpack_public_path__ + "static/media/vlajka_de_gray.5f8ff28e.svg";